import React from 'react'
// ##
import SubscriptionsTable from '../../modules/Subscription/components/SubscriptionsTable'

export default function SubscriptionPage() {
  return <SubscriptionsTable />
}
